import { Grid } from '@atgfr8/atg-ui-tailwind';
import { BasicModal } from '@components';
import {
  ContainerItem,
  ediConfigurationStore,
  updateEdiState,
} from '@store/customers/customerDetails';
import { isAdmin } from '@utils/utils';
import { createSignal } from 'solid-js';

import AssignedRuleModal from './AssignedRuleModal';
import EDIRulesDragAndDropMultipleList from './EDIRulesDragAndDropMultipleList';

type RulesTabContentProps = {
  initialData: {
    A: ContainerItem[];
    B: ContainerItem[];
  };
  keyToUpdate: keyof typeof ediConfigurationStore.ediData;
  key2: keyof typeof ediConfigurationStore.ediData;
};

const RulesTabContent = (props: RulesTabContentProps) => {
  const [selectedItem, setSelectedItem] = createSignal<{
    containerId: string;
    item: ContainerItem | null;
  } | null>(null);
  const [triggerFunction, setTriggerFunction] = createSignal<boolean>(false);

  const handleDragEnd = (containers: Record<string, ContainerItem[]>) => {
    updateEdiState({
      [props.keyToUpdate]: containers.A,
      [props.key2]: containers.B,
    });
  };

  const handleSetTriggerFunction = () => {
    setTriggerFunction(false);
    setSelectedItem(null);
  };

  return (
    <Grid container>
      <Grid item size={12} class={`${!isAdmin() && 'pointer-events-none'}`}>
        <EDIRulesDragAndDropMultipleList
          initialData={props.initialData}
          onDragEnd={handleDragEnd}
          setSelectedItem={setSelectedItem}
          keyToUpdate={props.keyToUpdate}
        />
      </Grid>
      <BasicModal
        title="Add/Edit Parameter"
        id="addOrEditParameter"
        footer={false}
        width="400px"
        onClose={() => {
          setTriggerFunction(true);
        }}
      >
        <AssignedRuleModal
          selectedItem={selectedItem}
          initialData={props.initialData}
          keyToUpdate={props.keyToUpdate}
          triggerFunction={triggerFunction}
          setTriggerFunction={handleSetTriggerFunction}
        />
      </BasicModal>
    </Grid>
  );
};

export default RulesTabContent;
